<style scoped>
@import url(../../style/home/footer.css);

@import url(../../style/productApplication/bottom-banner.css);
@import url(../../style/productApplication/product-nav.css);
@import url(../../style/productApplication/products-display.css);
@import url(../../style/productApplication/hot-products.css);

.image-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.hot-product-image .image-container {
  height: 180px;
}

/* 滚动动画相关样式 */
.scroll-animate {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.scroll-animate.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 为子元素添加延迟动画 */
.product-card,
.hot-product-card {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease-out;
}

.products-display-container.visible .product-card,
.hot-products-container.visible .hot-product-card {
  opacity: 1;
  transform: translateY(0);
}

/* 为产品卡片添加交错延迟 */
.product-card:nth-child(1) { transition-delay: 0.1s; }
.product-card:nth-child(2) { transition-delay: 0.2s; }
.product-card:nth-child(3) { transition-delay: 0.3s; }
.product-card:nth-child(4) { transition-delay: 0.4s; }

.hot-product-card:nth-child(1) { transition-delay: 0.1s; }
.hot-product-card:nth-child(2) { transition-delay: 0.2s; }
.hot-product-card:nth-child(3) { transition-delay: 0.3s; }

/* 覆盖全局/导航栏引入的 .product-title { text-align: left } */
.products-display-container .product-info,
.products-display-container .product-title,
.products-display-container .product-detail-link {
  text-align: center !important;
}
</style>

<template>
  <div class="home-container">
    <!-- 导入头部导航组件 -->
    <AppHeader />
    
    
    <div class="bottom-banner scroll-animate" ref="bannerRef">
      <div class="banner-background">
        <img
          :src="currentBannerMedia"
          :alt="productMenu[activeNavItem].title + '背景图'"
        />
      </div>
      <div class="banner-content">
        <h2>{{ productMenu[activeNavItem].title }}</h2>
      </div>
    </div>

   <!-- 产品类别导航栏 -->
    <div class="product-nav-container scroll-animate" ref="navRef">
      <div class="product-nav">
        <div 
          v-for="(item, idx) in productMenu" 
          :key="idx"
          class="nav-item"
          :class="{ active: activeNavItem === idx }"
          @click="selectNavItem(idx)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

    <!-- 产品展示模块 -->
    <div class="products-display-container scroll-animate" ref="productsRef">
      <div class="products-grid">
        <div 
          v-for="(product, index) in productsList" 
          :key="index"
          class="product-card"
        >
          <div class="product-info">
            <h3 class="product-title">{{ product.title }}</h3>
            <a href="javascript:;" class="product-detail-link" @click.prevent="navigateToProductDetail(product)">了解详情 &gt;</a>
          </div>
          <div class="product-image">
            <div class="image-container">
              <img :src="product.imageUrl" :alt="product.title" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hot-products-container scroll-animate" ref="hotProductsRef">
      <h2 class="hot-products-title">热门产品</h2>
      <div class="hot-products-grid">
        <div 
          v-for="(product, index) in hotProductsList" 
          :key="index"
          class="hot-product-card"
        >
          <div class="hot-product-image">
            <div class="image-container">
              <img :src="product.imageUrl" :alt="product.title" />
            </div>
          </div>
          <div class="hot-product-info">
            <h4 class="hot-product-title">{{ product.title }}</h4>
            <p v-if="product.model" class="hot-product-model">{{ product.model }}</p>
            <a href="javascript:;" class="hot-product-link" @click.prevent="navigateToProductDetail(product)">了解详情 &gt;</a>
          </div>
        </div>
      </div>
    </div>

  <!-- 底部 -->
  <AppFooter />
  
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import { formatImg } from '@/utils/formatImg';

export default {
  name: 'ProductApplicationPage',
  components: {
    AppHeader,
    AppFooter
  },
  props: {
    categoryIndex: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeNavItem: 0,
      allProducts: {},
      allProductsFlatList: [],
      allHotProducts: {},
      productMenu: [
        {
          title: '皮肤镜图像处理工作站',
          products: ['SMS-3000Ⅰ', 'SMS-3000Ⅱ', 'SMS-6000Ⅰ','SMS-3000Ⅱ'],
          bannerImage: 'homepage/spec-pics/spec-pic1.png'
        },
        {
          title: '皮肤科',
          products: ['触屏式皮肤镜', '手持式皮肤镜', '便携式皮肤镜'],
          bannerImage: 'homepage/spec-pics/spec-pic2.png'
        },
        {
          title: '医学美容科',
          products: ['面部检测仪', 'visia'],
          bannerImage: 'homepage/spec-pics/spec-pic3.png'
        },
        {
          title: '言语认知',
          products: ['便携式', '单屏幕', '平板式', '双屏'],
          bannerImage: 'homepage/spec-pics/spec-pic4.jpg'
        },
        {
          title: '消化内科',
          products: ['电子肠镜', '电子胃镜'],
          bannerImage: 'homepage/spec-pics/spec-pic5.jpg'
        },
        {
          title: '妇产科',
          products: ['4K电子阴道显微镜'],
          bannerImage: 'homepage/spec-pics/spec-pic1.png'
        }
      ]
    }
  },
  computed: {
    productsList() {
      return this.allProducts[this.activeNavItem] || [];
    },
    hotProductsList() {
      const currentCategoryProducts = this.allProducts[this.activeNavItem] || [];
      const currentCategoryProductModels = currentCategoryProducts.map(p => p.model);
      const currentCategoryProductTitles = currentCategoryProducts.map(p => p.title);

      const availableProducts = this.allProductsFlatList.filter(product => {
        return !currentCategoryProductModels.includes(product.model) &&
               !currentCategoryProductTitles.includes(product.title);
      });

      if (availableProducts.length <= 3) {
        return availableProducts;
      }

      const shuffled = [...availableProducts].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 3);
    },
    currentBannerMedia() {
      const category = this.productMenu[this.activeNavItem];
      if (category && category.bannerImage) {
        const media = category.bannerImage;
        if (typeof media === 'string' && /^https?:\/\//i.test(media)) {
          return media;
        }
        try {
          return require(`@/assets/images/${media}`);
        } catch (error) {
          console.warn(`Banner media not found: ${media}, using default`);
          return require('@/assets/images/homepage/spec-pics/spec-pic1.png');
        }
      }
      return require('@/assets/images/homepage/spec-pics/spec-pic1.png');
    }
  },
  async mounted() {
    if (this.categoryIndex) {
      this.updateActiveNavFromParams(this.categoryIndex);
    } else if (this.$route.params.categoryIndex) {
      this.updateActiveNavFromParams(this.$route.params.categoryIndex);
    }

    this.initScrollAnimation();
    this.initProductData();
  },
  watch: {
    '$route.params.categoryIndex'(newIndex) {
      this.updateActiveNavFromParams(newIndex);
    },
    categoryIndex(newIndex) {
      this.updateActiveNavFromParams(newIndex);
    }
  },
  methods: {
    initProductData() {
      const productImages = {
        'dppfj-001': require('@/assets/uploads/hrys/dppfj-001.png'),
        'sppfj-001': require('@/assets/uploads/hrys/sppfj-001.png'),
        'handheld': require('@/assets/uploads/hrys/handheld.jpg'),
        'Touchscreen': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731164921814.jpg',
        'portable': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731164822429.png',
        'speechPortable': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731170322849.png',
        'speechSingle': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731170418767.png',
        'speechTablet': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731170425041.jpg',
        'speechDual': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731170432399.png',
        'skinAnalyzer': require('@/assets/uploads/hrys/skinAnalyzer.png'),
        'ElectronicColonoscopy': require('@/assets/uploads/hrys/ElectronicColonoscopy.png'),
        'Colposcope': 'https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731172243424.jpg',
        'default': require('@/assets/images/product-ex.png')
      };

      const resolveProduct = (category, product) => {
        const hasModelPattern = /^[A-Za-z0-9-ⅠⅡ]+$/;
        const isModel = hasModelPattern.test(product);
        const speechProducts = ['便携式', '单屏幕', '平板式', '双屏'];
        const productTitle = speechProducts.includes(product)
          ? `言语认知${product}`
          : (isModel ? `${category.title} ${product}` : product);

        let imageUrl = productImages.default;
        if (product.includes('SMS-3000')) {
          imageUrl = productImages['dppfj-001'];
        } else if (product.includes('SMS-6000')) {
          imageUrl = productImages['sppfj-001'];
        } else if (product === '便携式' || productTitle === '言语认知便携式') {
          imageUrl = productImages.speechPortable;
        } else if (product === '单屏幕' || productTitle === '言语认知单屏幕') {
          imageUrl = productImages.speechSingle;
        } else if (product === '平板式' || productTitle === '言语认知平板式') {
          imageUrl = productImages.speechTablet;
        } else if (product === '双屏' || productTitle === '言语认知双屏') {
          imageUrl = productImages.speechDual;
        } else if (product.includes('手持式') || productTitle.includes('手持式皮肤镜')) {
          imageUrl = productImages['handheld'];
        } else if (product.includes('触屏式') || productTitle.includes('触屏式皮肤镜')) {
          imageUrl = productImages['Touchscreen'];
        } else if (product.includes('便携式皮肤镜') || productTitle.includes('便携式皮肤镜')) {
          imageUrl = productImages['portable'];
        } else if (product.includes('面部') || productTitle.includes('面部检测仪')) {
          imageUrl = productImages['skinAnalyzer'];
        } else if (product.includes('肠镜') || productTitle.includes('电子肠镜')) {
          imageUrl = productImages['ElectronicColonoscopy'];
        } else if (product.includes('阴道') || productTitle.includes('电子阴道显微镜')) {
          imageUrl = productImages['Colposcope'];
        }

        return {
          model: isModel ? product : '',
          title: productTitle,
          imageUrl: typeof imageUrl === 'string' ? formatImg(imageUrl) : imageUrl
        };
      };

      this.allProducts = {};
      this.allProductsFlatList = [];
      this.allHotProducts = {};

      this.productMenu.forEach((category, index) => {
        const categoryProducts = category.products.map(product => resolveProduct(category, product));
        this.allProducts[index] = categoryProducts;
        this.allProductsFlatList.push(...categoryProducts);
        this.allHotProducts[index] = category.products.slice(0, 2).map(product => resolveProduct(category, product));
      });

      const uniqueProducts = [];
      const productKeys = new Set();

      this.allProductsFlatList.forEach(product => {
        const key = `${product.title}-${product.model}`;
        if (!productKeys.has(key)) {
          productKeys.add(key);
          uniqueProducts.push(product);
        }
      });

      this.allProductsFlatList = uniqueProducts;
    },

    selectNavItem(idx) {
      this.activeNavItem = idx;
      console.log('Selected product category:', this.productMenu[idx].title);
    },

    navigateToProductDetail(product) {
      console.log('Product detail selected:', product);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.$router.push({
        path: '/specific-products',
        query: {
          productTitle: product.title,
          productModel: product.model
        }
      });
    },

    updateActiveNavFromParams(index) {
      if (index) {
        const parsedIndex = parseInt(index, 10);
        if (!isNaN(parsedIndex) && parsedIndex >= 0 && parsedIndex < this.productMenu.length) {
          this.activeNavItem = parsedIndex;
        }
      }
    },

    initScrollAnimation() {
      this.animatedElements = [
        this.$refs.bannerRef,
        this.$refs.navRef,
        this.$refs.productsRef,
        this.$refs.hotProductsRef
      ].filter(ref => ref);

      this.checkScrollPosition();
      window.addEventListener('scroll', this.handleScroll);
    },

    handleScroll() {
      this.checkScrollPosition();
    },

    checkScrollPosition() {
      const windowHeight = window.innerHeight;
      const revealPoint = 150;

      this.animatedElements.forEach((element, index) => {
        if (!element || element.classList.contains('visible')) return;

        const elementTop = element.getBoundingClientRect().top;

        if (elementTop < windowHeight - revealPoint) {
          setTimeout(() => {
            element.classList.add('visible');
          }, index * 300);
        }
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
